import React, { useState } from 'react';
import { apiFetch } from '../lib/apiFetch';
import { ApiResponse, AudioCliente, Cliente } from '../types';
import { toast } from '../lib/toast';

const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:4000/api';

interface Props {
    clientes: Cliente[];
    onClose: () => void;
    onSubido: () => void;
}

export const SubirAudioModal: React.FC<Props> = ({ clientes, onClose, onSubido }) => {
    const [clienteId, setClienteId] = useState('');
    const [archivo, setArchivo] = useState<File | null>(null);
    const [subiendo, setSubiendo] = useState(false);

    const handleSubir = async () => {
        if (!clienteId || !archivo) {
            toast.error('Elegí un cliente y un archivo de audio');
            return;
        }
        setSubiendo(true);
        try {
            const form = new FormData();
            form.append('cliente_id', clienteId);
            form.append('archivo', archivo);
            const res = await apiFetch(`${API_BASE}/audios`, { method: 'POST', body: form });
            const json: ApiResponse<AudioCliente> = await res.json();
            if (json.success) {
                toast.success(
                    json.data?.tarea_id
                        ? `Audio recibido — tarea #${json.data.tarea_id} creada en el tablero`
                        : 'Audio recibido, en cola para procesar'
                );
                onSubido();
            } else {
                toast.error(json.error || 'Error al subir el audio');
            }
        } catch (e) {
            toast.error('No se pudo conectar con el servidor');
        } finally {
            setSubiendo(false);
        }
    };

    return (
        <div className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-50 p-4" onClick={onClose}>
            <div className="bg-white rounded-xl shadow-xl w-full max-w-md p-5" onClick={e => e.stopPropagation()}>
                <h3 className="text-base font-semibold text-slate-800 mb-4">Subir audio de cliente</h3>

                <label className="block text-xs font-medium text-slate-600 mb-1">Cliente</label>
                <select
                    value={clienteId}
                    onChange={e => setClienteId(e.target.value)}
                    className="w-full text-sm border border-slate-300 rounded-lg px-3 py-2 mb-3"
                >
                    <option value="">Elegí un cliente...</option>
                    {clientes.map(c => (
                        <option key={c.id} value={c.id}>{c.empresa}</option>
                    ))}
                </select>

                <label className="block text-xs font-medium text-slate-600 mb-1">Archivo (OGG, MP3, M4A, WAV, AAC — máx 25MB)</label>
                <input
                    type="file"
                    accept=".ogg,.mp3,.m4a,.wav,.aac"
                    onChange={e => setArchivo(e.target.files?.[0] || null)}
                    className="w-full text-sm border border-slate-300 rounded-lg px-3 py-2 mb-4"
                />

                <div className="flex justify-end gap-2">
                    <button onClick={onClose} className="px-3 py-1.5 text-sm text-slate-600 hover:text-slate-800">
                        Cancelar
                    </button>
                    <button
                        onClick={handleSubir}
                        disabled={subiendo}
                        className="px-3 py-1.5 text-sm bg-slate-800 text-white rounded-lg hover:bg-slate-700 disabled:opacity-50"
                    >
                        {subiendo ? 'Subiendo...' : 'Subir'}
                    </button>
                </div>
            </div>
        </div>
    );
};
